import { mapActions,mapGetters } from "vuex";
export default {
  name: "SimpleWarningDialog",
  mixins: [],
  props: {
    icon: {
      type: String,
      default: "mdi-alert"
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    subtext: {
      type: String,
      default: ""
    },
    primaryBtnText: {
      type: String,
      default: "ok"
    },
    secondaryBtn: {
      type: Boolean,
      default: false
    },
    secondaryBtnText: {
      type: String,
      default: "cancel"
    }
  },
  computed: {
    ...mapGetters(["dialogOkLoading","dialogCancelLoading"])
  },
  beforeDestroy(){
    this.setDialogOkLoading(false);
    this.setDialogCancelLoading(false);
  },
  created() {
    this.show = true;
  },
  methods: {
    ...mapActions(["setDialogOkLoading","setDialogCancelLoading"]),
    onPrimary() {
      this.setDialogOkLoading(true);
      this.$emit("onPrimary");
    },
    onSecondary() {
      this.setDialogCancelLoading(true);
      this.$emit("onSecondary");
    },
    onClickOutside() {
      if (this.secondaryBtn) {
        this.onSecondary();
      } else {
        this.onPrimary();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/SimpleWarningDialog.js